module.exports = __webpack_public_path__ + "img/comoros.63012ee0.svg";